
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SwitchedContainer extends Vue {
    @Prop({ default: false, type: Boolean, required: true })
    value!: boolean;

    @Prop({ required: true, type: String })
    label!: string;

    @Prop({ default: '', type: String })
    description!: string;

    @Prop({ default: false, type: Boolean })
    grouped!: boolean;

    @Prop({ default: false, type: Boolean })
    disabled!: boolean;

    @Prop({ default: '', type: String })
    disabledReason!: string;

    currentValue = null as unknown as boolean;

    created() {
        this.currentValue = this.value;
    }

    @Watch('currentValue')
    onCurrentValueChange() {
        if (this.currentValue !== this.value) {
            this.$emit('input', this.currentValue);
        }
    }

    @Watch('value')
    onValueChange() {
        if (this.currentValue !== this.value) {
            this.currentValue = this.value;
        }
    }

    test() {
        console.log('Caught an event from slot');
    }
}
